import { connect } from 'react-redux';
import OpticsOrder from './OpticsOrder';
import { actions } from '../../../../redux/modules/consultPrint';
import { resetStore } from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.print_consult,
        ...state.login.me
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(OpticsOrder);
